import { render } from "./AuditImportPreviewFooter.vue?vue&type=template&id=66768b51"
import script from "./AuditImportPreviewFooter.vue?vue&type=script&lang=js"
export * from "./AuditImportPreviewFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__